import React from 'react';
import { PiGridFourBold, PiListBold } from 'react-icons/pi';

export type ViewMode = 'grid' | 'list';

interface ViewModeToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

const ViewModeToggle: React.FC<ViewModeToggleProps> = ({ value, onChange }) => {
  const base =
    'p-1.5 rounded transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary';
  const active =
    'text-gray-800 dark:text-gray-100 bg-gray-200 dark:bg-gray-600';
  const inactive =
    'text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300';

  return (
    <div className="flex items-center gap-0.5" role="group" aria-label="View mode">
      <button
        type="button"
        aria-label="Grid view"
        aria-pressed={value === 'grid'}
        className={`${base} ${value === 'grid' ? active : inactive}`}
        onClick={() => onChange('grid')}
      >
        <PiGridFourBold size={18} />
      </button>
      <button
        type="button"
        aria-label="List view"
        aria-pressed={value === 'list'}
        className={`${base} ${value === 'list' ? active : inactive}`}
        onClick={() => onChange('list')}
      >
        <PiListBold size={18} />
      </button>
    </div>
  );
};

export default ViewModeToggle;

